import { Box, Flex, Typography } from '@iheartjane/reefer';
import type { ButtonSize } from '@iheartjane/reefer';

import { AppleSignInButton } from './appleButton';
import { GoogleSignInButton } from './googleButton';

interface ContinueWithProps {
  buttonSize?: ButtonSize;
  onAppleClick(): void;
  onGoogleClick(): void;
  showAppleLogin: boolean;
  showGoogleLogin: boolean;
}

export const ContinueWith = ({
  buttonSize,
  onAppleClick,
  onGoogleClick,
  showAppleLogin,
  showGoogleLogin,
}: ContinueWithProps) => {
  return (
    <Box width="100%" data-test-id="social-sign-in">
      <Typography textAlign="center" color="grays-mid">
        Continue with
      </Typography>
      <Flex width="100%" flexDirection="row" my={16} alignItems="center">
        {showAppleLogin && (
          <AppleSignInButton
            onClick={onAppleClick}
            label="Apple"
            mr={16}
            size={buttonSize}
            ariaLabel="Continue with Apple"
          />
        )}
        {showGoogleLogin && (
          <GoogleSignInButton
            onClick={onGoogleClick}
            label="Google"
            size={buttonSize}
            ariaLabel="Continue with Google"
          />
        )}
      </Flex>
      <Typography textAlign="center" color="grays-mid">
        or
      </Typography>
    </Box>
  );
};
